import rill from "rill";

import ensureUser from "../../middleware/ensure-user";
import ensureAdmin from "../../middleware/ensure-admin";
import Users from "./users";
import Reports from "./reports";
import exerciseLibraryController from "./exercise-library/exercise-library-controller";
import tutorialCategoryController from "./tutorials/tutorial-category.controller";

const Admin = (app) => {
  app.at(
    "/admin/*",
    ensureUser,
    ensureAdmin,
    rill()
      .setup(Users)
      .setup(Reports)
      .setup(exerciseLibraryController)
      .setup(tutorialCategoryController)
  );
};

export default Admin;
